var map = {
	"./1.svg": "a881",
	"./2.svg": "743f",
	"./3.svg": "41a7",
	"./4.svg": "8280",
	"./5.svg": "9566",
	"./arrow-down.svg": "c874",
	"./arrow-up.svg": "a3f8",
	"./bed.svg": "f035",
	"./book.svg": "fc4e",
	"./bookmark.svg": "7253",
	"./burger.svg": "ada2",
	"./checkmark.svg": "1ec3",
	"./chevron.svg": "079d",
	"./close.svg": "8b1b",
	"./date.svg": "70f5",
	"./down-arrow-icon.svg": "4bfc",
	"./down.svg": "d8aa",
	"./facebook.svg": "8485",
	"./heart.svg": "7d16",
	"./instagram.svg": "bd6c",
	"./linkedin.svg": "9ed9",
	"./location.svg": "d2eb",
	"./logo-inverted.svg": "aa24",
	"./my-hallam.svg": "20f3",
	"./office.svg": "3dec",
	"./person.svg": "d104",
	"./pound.svg": "d81b",
	"./search.svg": "d103",
	"./time.svg": "79aa",
	"./trophy.svg": "e6bc",
	"./twitter.svg": "acf9",
	"./white-down-arrow-icon.svg": "0c06",
	"./youtube.svg": "11ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";